import React from "react";

import svg from "../../assets/images/icons/steps/Run Rule Set f.svg";

export const RunRuleSetIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Run Rule Set"}
    />
);
